import {
  hasConsentForServices,
  initializePluginWithConsent,
  ServiceIds,
} from 'chimera/all/plugins/config/usercentrics.client'
import Clarity from '@microsoft/clarity'
import { EventBus } from 'chimera/all/plugins/eventbus'
import { bindEvents } from './bind'

/**
 * Options object which is merged with passed options and
 * can be retrieved by importing getOptions function.
 *
 * @type {object}
 */
let options = {}

/**
 * @returns {object}
 */
export const getOptions = () => options

/**
 * Documentation: https://learn.microsoft.com/en-us/clarity/setup-and-installation/clarity-api#javascript-apis
 *
 * @param {object} Vue
 * @param {object} _options
 */
export default (Vue, _options) => {
  options = { ...options, ..._options }

  const { projectId, store, sessionId, visitorId } = options
  if (!projectId) {
    return
  }

  Clarity.init(projectId)
  Clarity.consent(false)

  const requiredServices = [ServiceIds.CLARITY]

  const QUEUE_EVENT_KEY = 'clarity'
  const enqueueEvent = async (eventName, fn) =>
    (await hasConsentForServices(requiredServices))
      ? fn()
      : store.dispatch('queue/enqueue', {
          key: QUEUE_EVENT_KEY,
          eventName,
          func: fn,
        })

  initializePluginWithConsent(() => {
    Clarity.consent(true)

    if (!visitorId || !sessionId) {
      EventBus.emitWarningAppErrorEvent(
        new Error('Could not add Clarity user attribution'),
        {
          visitorId,
          sessionId,
        },
      )
    }

    Clarity.identify(visitorId, sessionId)

    store.dispatch('queue/flush', QUEUE_EVENT_KEY)
  }, requiredServices)

  bindEvents(Vue, { enqueueEvent })
}
